









































import {
  defineComponent,
  computed,
  ref,
  reactive,
  watch,
  PropType,
} from '@vue/composition-api';
import { downloadObjectUrl } from '@/lib/downloadHelper';
import { dtFormat } from '@/lib/dateHelper';
interface ModalImageViewState {
  maxWidth: number | null;
  currentIndex: number;
}

export default defineComponent({
  name: 'modal-image-view',
  props: {
    title: {
      type: String,
      default: '',
    },
    imageUrls: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    downloadFilenameTemplate: {
      type: String,
      default: '',
    },
    initialIndex: {
      type: Number,
      default: 0,
    },
  },
  setup(props, { emit }) {
    const refImg1 = ref<HTMLImageElement>();
    const state = reactive<ModalImageViewState>({
      maxWidth: null,
      currentIndex: props.initialIndex,
    });

    watch(
      [() => props.initialIndex, () => props.imageUrls],
      ([newIndex]) => {
        state.currentIndex = newIndex;
      },
    );

    const currentImageUrl = computed<string>(() => {
      return props.imageUrls[state.currentIndex];
    });

    const onImageLoad = () => {
      const imgDispWidth = refImg1.value?.width || 0;
      const imgDispHeight = refImg1.value?.height || 0;
      if (imgDispWidth <= imgDispHeight) {
        state.maxWidth = null;
        return;
      }
      state.maxWidth = 75;
    };
    const trimmedTitle = computed<string>(() => {
      const isWideMode = state.maxWidth !== null;
      const maxLen = isWideMode ? 46 : 22;
      return props.title.length > maxLen
        ? `${props.title.slice(0, maxLen)}...`
        : props.title;
    });
    const downloadImage = () => {
      const timestamp = dtFormat(new Date(), 'yyyymmddHHMMSS');
      const downloadFilename = props.downloadFilenameTemplate.replace(/\$TIMESTAMP/, timestamp);
      downloadObjectUrl(currentImageUrl.value, downloadFilename);
    };
    const onClose = () => {
      emit('close');
    };
    const showPrevious = () => {
      if (state.currentIndex > 0) {
        state.maxWidth = null;
        state.currentIndex--;
      }
    };
    const showNext = () => {
      if (state.currentIndex < props.imageUrls.length - 1) {
        state.maxWidth = null;
        state.currentIndex++;
      }
    };

    return {
      state,
      refImg1,
      trimmedTitle,
      currentImageUrl,
      onImageLoad,
      downloadImage,
      onClose,
      showPrevious,
      showNext,
    };
  },
});
